<div class="mn-rows"><slot /></div>
